/**
 * ProtectedRoute
 * 
 * Wrapper that redirects unauthenticated users directly to Auth0 login.
 * Shows loading spinner while auth state is being determined.
 */

import React, { ReactNode, useEffect } from 'react';
import { useAuth } from '../../context';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, login } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [isLoading, isAuthenticated, login]);

  if (isLoading || !isAuthenticated) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-secondary)',
      }}>
        <div style={{
          width: 36,
          height: 36,
          border: '3px solid var(--border-light)',
          borderTopColor: 'var(--primary-600)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
